/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterGroup } from '../../models/work-center-group';

export interface GetWorkCenterGroupsForActiveMachines$Params {
}

export function getWorkCenterGroupsForActiveMachines(http: HttpClient, rootUrl: string, params?: GetWorkCenterGroupsForActiveMachines$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkCenterGroup>>> {
  const rb = new RequestBuilder(rootUrl, getWorkCenterGroupsForActiveMachines.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkCenterGroup>>;
    })
  );
}

getWorkCenterGroupsForActiveMachines.PATH = '/api/v1/WorkCenterGroup/WorkCenterGroupsForActiveMachines';
